import { v4 } from 'uuid';

import type { ForwardAccumulatorProperties, FxForwardAccumulator } from '@/store/forwardAccumulator/state.ts';
import { DEFAULT_PRICE_TYPE } from '@/store/targetAccumulator/state.ts';

export const initForwardAccumulator: (clientId?: number, currencyPair?: string) => FxForwardAccumulator = (
  clientId?: number,
  currencyPair?: string,
) =>
  ({
    type: 'FxForwardAccumulator',
    clientId,
    properties: {
      currencyPair,
      hedgeType: 'Live',
      isPriceable: false,
      rfsVersion: 0,
      step: null,
      rfs: {
        status: 'CANCELLED',
      },
      execution: {
        status: 'PENDING', // ??
      },
      accuType: 'Standard',

      notionalCurrencyIndex: 1,
      premiumPriceType: DEFAULT_PRICE_TYPE,
      premiumTypeCurrencyIndex: 1,
      amountMode: 'Fixing',
      clientsWay: 'Buy',
      leverage: 2,
      hedgeAmount: null,
      hedgePaymentDate: null,
      marginCurrency: '',
      notional: null,
      premiumDate: null,
      premiumDateTenor: null,
      possibleHedgeTypes: [],
      mifid: { records: [] },

      hedgeCurrencyIndex: 1,
      summary: '',
      targetProfitType: 'NONE',

      uiState: { displayMode: 'Pricer' },
    },
    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  }) satisfies FxForwardAccumulator;

export const generateEmptyForwardAccumulator: (
  props?: Partial<ForwardAccumulatorProperties>,
  clientId?: number,
) => FxForwardAccumulator = (props?: Partial<ForwardAccumulatorProperties>, clientId?: number) =>
  ({
    type: 'FxForwardAccumulator',
    clientId,
    properties: {
      hedgeType: 'Live',
      isPriceable: false,
      rfsVersion: 0,
      accuType: 'Standard',
      rfs: {
        status: 'CANCELLED',
      },
      execution: {
        status: 'PENDING',
      },
      notionalCurrencyIndex: 1,
      premiumPriceType: DEFAULT_PRICE_TYPE,
      premiumTypeCurrencyIndex: 1,
      amountMode: 'Fixing',
      clientsWay: 'Buy',
      leverage: 2,
      hedgeAmount: null,
      hedgePaymentDate: null,
      mifid: { records: [] },

      marginCurrency: '',
      notional: null,
      premiumDate: null,
      premiumDateTenor: null,
      possibleHedgeTypes: [],

      hedgeCurrencyIndex: 1,
      summary: '',
      targetProfitType: 'NONE',

      uiState: { displayMode: 'Pricer' },

      ...props,
    },
    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  }) satisfies FxForwardAccumulator;

export const calendarProperties = [
  'fixingDate',
  'EKI',
  'strike',
  'step',
  'amount',
  'leverageAmount',
  'deleteIcon',
  'paymentDate',
] as const;

export type SchedulerCalendarProperty = (typeof calendarProperties)[number];
